/* LBX availability ordering and supplier-orderable build 2026-10-06 */
(function () {
  'use strict';
  var endpoint = 'https://hub.labosch.es/api/public/reservations/stock';
  var phone = '34690041276';
  var generation = 0;

  function render(card, own, supplier) {
    if (card.getAttribute('data-lbx-stock-ready') !== 'true' || card.getAttribute('data-lbx-stock-error') === 'true') return;
    var label = card.querySelector('[data-lbx-store-availability]');
    if (!label) return;
    own = Math.max(0, Number(own) || 0);
    supplier = Math.max(0, Number(supplier) || 0);
    var scoped = card.__lbxMatchedVariants || matrix(card);
    var live = card.__lbxLiveStock || {};
    var incoming = scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'incoming'; });
    var assumed = scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'assumed'; });
    var arrival = scoped.map(function (variant) { return live[String(variant.id)] && live[String(variant.id)].estimatedArrival; }).filter(Boolean)[0] || '';
    var orderable = scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'supplier_orderable'; });
    var uncertain = assumed || scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'unknown'; });
    var state = own > 0 ? 'in-stock' : supplier > 0 ? 'supplier-stock' : orderable || incoming ? 'incoming' : uncertain ? 'unknown' : 'sold-out';
    label.classList.remove('is-sold-out', 'is-out-of-stock', 'is-available', 'is-supplier', 'is-reservation', 'is-hub-reservation');
    label.classList.add(own > 0 ? 'is-available' : supplier > 0 ? 'is-supplier' : orderable || incoming ? 'is-hub-reservation' : 'is-sold-out');
    var copy = label.querySelector('.lbx109-stock-copy');
    var title = copy && copy.querySelector('b');
    var detail = copy && copy.querySelector('small');
    if (title) title.textContent = state === 'unknown' ? 'Consultar disponibilidad' : state === 'sold-out' ? 'Sin stock' : 'Disponible';
    if (own > 0 && copy) {
      if (!detail) { detail = document.createElement('small'); copy.appendChild(detail); }
      detail.textContent = '24/48h laborables';
    } else if (own === 0 && (supplier > 0 || incoming || orderable) && copy) {
      if (!detail) { detail = document.createElement('small'); copy.appendChild(detail); }
      detail.textContent = arrival || (supplier > 0 ? 'En 10 días laborables' : 'En 3–4 semanas');
    } else if (detail) detail.remove();
    card.setAttribute('data-lbx-product-stock-status', state);
    card.setAttribute('data-lbx-availability', state);
    card.classList.toggle('is-sold-out', state === 'sold-out');
    syncStockVariantLinks(card, matrix(card), live);
    updateWhatsapp(card, state === 'sold-out' || state === 'unknown');
  }

  function updateWhatsapp(card, show) {
    var footer = card.querySelector('.lbx-canon-card__footer');
    if (!footer) return;
    var link = footer.querySelector('[data-lbx-ask-availability]');
    if (!show) { if (link) link.remove(); return; }
    if (!link) {
      link = document.createElement('a');
      link.setAttribute('data-lbx-ask-availability', '');
      link.className = 'lbx-ask-availability';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'Preguntar por la disponibilidad';
      footer.appendChild(link);
    }
    var variants = matrix(card);
    var selected = card.__lbxSelectedVariant || (variants.length === 1 ? variants[0] : null);
    var productUrl = (card.querySelector('.lbx-canon-card__title') || {}).href || window.location.href;
    if (!selected) {
      link.textContent = 'Elegir variante para preguntar';
      link.href = productUrl;
      link.removeAttribute('target');
      return;
    }
    link.textContent = 'Preguntar por la disponibilidad';
    link.target = '_blank';
    var detail = Array.isArray(selected.options) ? ' · ' + selected.options.join(' / ') : '';
    var message = 'Hola, quiero preguntar por la disponibilidad de ' + (card.getAttribute('data-lbx-title') || 'esta bicicleta') + detail + ' (variante ' + selected.id + '). ' + productUrl;
    link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }

  function syncCardVariantMoney(card, selected) {
    if (!Number.isSafeInteger(selected.priceCents) || selected.priceCents < 0 || typeof selected.priceLabel !== 'string' || !selected.priceLabel) return;
    var box = card.querySelector('.lbx-canon-card__price');
    if (!box) return;
    var moneyKey = JSON.stringify([selected.id, selected.priceCents, selected.compareAtCents, selected.priceLabel, selected.compareAtLabel]);
    if (card.__lbxVariantMoneyKey === moneyKey) return;
    card.__lbxVariantMoneyKey = moneyKey;
    var sale = Number.isSafeInteger(selected.compareAtCents) && selected.compareAtCents > selected.priceCents && typeof selected.compareAtLabel === 'string' && !!selected.compareAtLabel;
    var amount = document.createElement('strong');
    amount.textContent = selected.priceLabel;
    box.replaceChildren(amount);
    if (sale) {
      var compare = document.createElement('s');
      compare.textContent = selected.compareAtLabel;
      box.appendChild(compare);
    }
    card.setAttribute('data-lbx-price', String(selected.priceCents / 100));
    card.setAttribute('data-lbx-price-cents', String(selected.priceCents));
    card.setAttribute('data-lbx-sale', String(sale));
    card.setAttribute('data-lbx-discount-pct', String(sale ? Math.floor((selected.compareAtCents - selected.priceCents) * 100 / selected.compareAtCents) : 0));
    card.classList.toggle('is-sale', sale);
    var badge = card.querySelector('.lbx-canon-card__badge');
    if (!badge && sale) {
      var media = card.querySelector('.lbx-canon-card__media');
      if (media) { badge = document.createElement('span'); badge.className = 'lbx-canon-card__badge'; badge.textContent = 'OFERTA'; media.appendChild(badge); }
    }
    if (badge && !sale) badge.remove();
    else if (badge) badge.hidden = false;
  }

  function syncCardVariantBattery(card, selected) {
    var capacity = Number(selected.batteryWh);
    if (!Number.isSafeInteger(capacity) || capacity <= 0) return;
    var row = card.querySelector('.lbx-canon-card__spec--battery');
    if (!row) {
      var specs = card.querySelector('.lbx-canon-card__specs');
      if (!specs) return;
      row = document.createElement('div'); row.className = 'lbx-canon-card__spec lbx-canon-card__spec--battery';
      var label = document.createElement('dt'); label.textContent = 'BATERÍA';
      row.appendChild(label); row.appendChild(document.createElement('dd')); specs.appendChild(row);
    }
    var value = row.querySelector('dd');
    var text = String(capacity) + ' Wh';
    if (value && value.textContent !== text) value.textContent = text;
  }

  function lowestPricedVariant(variants) {
    return variants.reduce(function (best, variant) {
      if (!Number.isSafeInteger(Number(variant.id)) || Number(variant.id) <= 0 ||
          !Number.isSafeInteger(variant.priceCents) || variant.priceCents < 0 ||
          typeof variant.priceLabel !== 'string' || !variant.priceLabel) return best;
      return !best || variant.priceCents < best.priceCents ? variant : best;
    }, null);
  }

  function syncStockVariantLinks(card, variants, live) {
    var candidates = Array.isArray(card.__lbxMatchedVariants) ? card.__lbxMatchedVariants : variants;
    var selected = candidates.find(function (variant) {
      var stock = live[String(variant.id)] || {};
      return Number(stock.storeStock || 0) > 0;
    }) || candidates.find(function (variant) {
      var stock = live[String(variant.id)] || {};
      return Number(stock.supplierStock || 0) > 0 || stock.state === 'supplier_orderable' || stock.state === 'incoming';
    }) || (Array.isArray(card.__lbxMatchedVariants) ? candidates[0] : lowestPricedVariant(candidates));
    if (!selected) return;
    card.__lbxSelectedVariant = selected;
    syncCardVariantMoney(card, selected);
    syncCardVariantBattery(card, selected);
    var image = card.querySelector('.lbx-canon-card__image');
    if (image && selected.image) {
      try {
        var imageUrl = new URL(selected.image, window.location.href);
        if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
          image.setAttribute('src', imageUrl.href);
          image.setAttribute('srcset', [320, 480, 680, 900, 1200].map(function (width) {
            var sized = new URL(imageUrl.href); sized.searchParams.set('width', String(width));
            return sized.href + ' ' + width + 'w';
          }).join(', '));
          image.setAttribute('alt', (card.getAttribute('data-lbx-title') || '') + (selected.options ? ' · ' + selected.options.join(' / ') : ''));
        }
      } catch (_) {}
    }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        if (url.pathname === new URL(window.location.href).pathname) return;
        url.searchParams.set('variant', String(selected.id));
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (_) {}
    });
  }

  function unknown(card) {
    // A failed/partial HUB read is not proof of zero stock. Keep the Shopify
    // adapter quantities as a safe fallback and disclose that the live check is
    // pending when neither local quantity is available.
    var own = Math.max(0, Number(card.getAttribute('data-lbx-own-stock-total') || card.getAttribute('data-lbx-own-stock') || 0) || 0);
    var supplier = Math.max(0, Number(card.getAttribute('data-lbx-supplier-stock-total') || card.getAttribute('data-lbx-supplier-stock') || 0) || 0);
    if (own > 0 || supplier > 0) {
      card.__lbxLiveStock = {};
      card.setAttribute('data-lbx-stock-error', 'false');
      card.setAttribute('data-lbx-stock-ready', 'true');
      card.setAttribute('data-lbx-all-own-stock', String(own));
      card.setAttribute('data-lbx-all-supplier-stock', String(supplier));
      card.setAttribute('data-lbx-own-stock', String(own));
      card.setAttribute('data-lbx-supplier-stock', String(supplier));
      render(card, own, supplier);
      return;
    }
    // A missing read cannot establish factory availability from model year.
    var incomingFallback = false;
    var fallbackState = 'unknown';
    card.__lbxLiveStock = {};
    card.setAttribute('data-lbx-stock-error', 'true');
    card.setAttribute('data-lbx-stock-ready', 'true');
    card.setAttribute('data-lbx-product-stock-status', fallbackState);
    card.setAttribute('data-lbx-availability', fallbackState);
    card.classList.toggle('is-sold-out', !incomingFallback);
    var label = card.querySelector('[data-lbx-store-availability]');
    if (label) {
      label.classList.remove('is-available', 'is-supplier', 'is-reservation', 'is-hub-reservation', 'is-sold-out', 'is-checking');
      label.classList.add(incomingFallback ? 'is-hub-reservation' : 'is-sold-out');
      var copy = label.querySelector('.lbx109-stock-copy');
      var title = copy && copy.querySelector('b');
      var detail = copy && copy.querySelector('small');
      if (title) title.textContent = incomingFallback ? 'Disponible' : 'Consultar disponibilidad';
      if (incomingFallback) {
        if (copy && !detail) { detail = document.createElement('small'); copy.appendChild(detail); }
        if (detail) detail.textContent = 'En 3–4 semanas';
      } else if (detail) detail.remove();
    }
    updateWhatsapp(card, !incomingFallback);
  }

  function cards() { return Array.from(document.querySelectorAll('[data-lbx-product-card]')); }
  function matrix(card) {
    try { return JSON.parse(card.querySelector('[data-lbx-v103-variants]').textContent).variants || []; }
    catch (_) { return []; }
  }

  async function refresh() {
    var current = ++generation;
    var items = cards();
    // Paint a deterministic state before the first network round-trip. A
    // slow/blocked HUB request must never leave the storefront in
    // «Comprobando disponibilidad» indefinitely; the live response below
    // replaces this fallback as soon as it arrives.
    items.forEach(function (card) {
      if (card.getAttribute('data-lbx-stock-ready') !== 'true') unknown(card);
    });
    var ids = Array.from(new Set(items.flatMap(function (card) { return matrix(card).map(function (variant) { return String(variant.id); }); })));
    var values = {};
    var groups = [];
    for (var start = 0; start < ids.length; start += 30) groups.push(ids.slice(start, start + 30));
    var nextGroup = 0;
    var painted = new Set();
    function paintReadyCards() {
      if (current !== generation) return;
      var changed = false;
      items.forEach(function (card) {
        if (painted.has(card)) return;
        var variants = matrix(card);
        if (!variants.every(function (variant) { return Object.prototype.hasOwnProperty.call(values, String(variant.id)); })) return;
        painted.add(card);
        changed = true;
        var own = 0, supplier = 0, missing = false;
        var live = {};
        variants.forEach(function (variant) {
          var id = String(variant.id);
          var value = values[id];
          var staticOwn = Math.max(0, Number(variant.ownStock || 0) || 0);
          var staticSupplier = Math.max(0, Number(variant.supplierStock || 0) || 0);
          // The public route reads Proveedores inventory directly. A verified
          // zero must replace an older positive quantity on the card.
          if (!value || value.state === 'unknown') {
            if (staticOwn > 0 || staticSupplier > 0) {
              value = { storeStock: staticOwn, supplierStock: staticSupplier, estimatedArrival: '', storeLocations: [], state: 'fallback', fallback: true };
            } else { missing = true; return; }
          } else {
            value = Object.assign({}, value);

          }
          live[id] = value;
          own += Number(value.storeStock || 0);
          supplier += Number(value.supplierStock || 0);
        });
        card.__lbxLiveStock = live;
        syncStockVariantLinks(card, variants, live);
        card.removeAttribute('data-lbx-stock-error');
        card.setAttribute('data-lbx-stock-ready', 'true');
        card.setAttribute('data-lbx-all-own-stock', String(own));
        card.setAttribute('data-lbx-all-supplier-stock', String(supplier));
        card.setAttribute('data-lbx-own-stock', String(own));
        card.setAttribute('data-lbx-supplier-stock', String(supplier));
        if (!variants.length || missing && own <= 0 && supplier <= 0 && !Object.values(live).some(function (value) { return value.state === 'assumed' || value.state === 'incoming' || value.state === 'supplier_orderable'; })) unknown(card);
        else render(card, own, supplier);
      });
      if (changed) {
        document.dispatchEvent(new CustomEvent('lbx:hub-availability'));
        sortCardsByAvailability();
      }
    }
    async function worker() {
      while (nextGroup < groups.length) {
        var group = groups[nextGroup++];
        try {
          var response = await fetch(endpoint + '?variantIds=' + encodeURIComponent(group.join(',')), { cache: 'no-store', signal: AbortSignal.timeout(7000) });
          if (!response.ok) throw new Error('stock');
          var data = await response.json();
          if (!data.ok || !data.variants) throw new Error('stock');
          group.forEach(function (id) { values[id] = data.variants[id] || null; });
        } catch (_) {
          group.forEach(function (id) { values[id] = null; });
        }
        paintReadyCards();
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, groups.length) }, worker));
    paintReadyCards();
  }

  function sortCardsByAvailability() {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (_) { return; }
    // Availability is the primary storefront order for every catalog view.
    // Shopify's selected sort remains the stable tie breaker within a tier.
    var list = document.querySelector('[data-lbx-product-list]');
    if (!list) return;
    var cardsList = Array.from(list.querySelectorAll('[data-lbx-product-card]'));
    cardsList.sort(function (a, b) {
      var aOwn = Math.max(0, Number(a.getAttribute('data-lbx-own-stock') || a.getAttribute('data-lbx-all-own-stock') || a.getAttribute('data-lbx-own-stock-total') || 0) || 0);
      var aSupplier = Math.max(0, Number(a.getAttribute('data-lbx-supplier-stock') || a.getAttribute('data-lbx-all-supplier-stock') || a.getAttribute('data-lbx-supplier-stock-total') || 0) || 0);
      var bOwn = Math.max(0, Number(b.getAttribute('data-lbx-own-stock') || b.getAttribute('data-lbx-all-own-stock') || b.getAttribute('data-lbx-own-stock-total') || 0) || 0);
      var bSupplier = Math.max(0, Number(b.getAttribute('data-lbx-supplier-stock') || b.getAttribute('data-lbx-all-supplier-stock') || b.getAttribute('data-lbx-supplier-stock-total') || 0) || 0);
      var aTier = aOwn > 0 ? 3 : (aSupplier > 0 ? 2 : 0);
      var bTier = bOwn > 0 ? 3 : (bSupplier > 0 ? 2 : 0);
      if (aTier !== bTier) return bTier - aTier;
      var selectedSort=params.get('sort_by')||'';
      if (selectedSort === 'price-ascending' || selectedSort === 'price-descending') {
        var aPrice = Number(a.getAttribute('data-lbx-price'));
        var bPrice = Number(b.getAttribute('data-lbx-price'));
        if (Number.isFinite(aPrice) && Number.isFinite(bPrice) && aPrice !== bPrice) return (aPrice - bPrice) * (selectedSort === 'price-ascending' ? 1 : -1);
      }
      if(selectedSort && selectedSort!=='manual' && selectedSort!=='most-relevant')return Number(a.getAttribute('data-lbx-native-order')||0)-Number(b.getAttribute('data-lbx-native-order')||0);
      if (aTier === 3) return bOwn - aOwn;
      if (aTier === 2) return bSupplier - aSupplier;
      return 0;
    });
    cardsList.forEach(function (card) { list.appendChild(card); });
  }
  window.lbxHubAvailability = { render: render, refresh: refresh, sort: sortCardsByAvailability };
  function syncAllStockLinks() {
    cards().forEach(function (card) {
      var variants = matrix(card), live = card.__lbxLiveStock || {};
      if (!variants.length) return;
      syncStockVariantLinks(card, variants, live);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
  window.setTimeout(syncAllStockLinks, 1800);
  window.setInterval(syncAllStockLinks, 4000);
  ['lbx:catalog-updated', 'shopify:section:load'].forEach(function (name) { document.addEventListener(name, function () { refresh(); sortCardsByAvailability(); }); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  window.setInterval(function () { if (!document.hidden) refresh(); }, 30000);
})();
